/**
 * Custom Enquiry Modal logic
 * Handles opening the modal, populating product data, and closing it.
 * This script delegates and uses the centralized window functions to ensure ARIA compliance.
 */
(function() {
  const modal = document.getElementById('Modal-Enquiry');
  if (!modal) return;

  /**
   * Delegates the click event to open the modal using global functions
   */
  document.addEventListener('click', function(e) {
    const trigger = e.target.closest('.js-btn-enquiry');
    if (trigger) {
      e.preventDefault();
      const title = trigger.getAttribute('data-product-title') || 'Product';
      const type = trigger.getAttribute('data-product-type') || 'Inquiry';
      
      if (typeof window.openEnquiryModal === 'function') {
        window.openEnquiryModal(title, type);
      } else {
        // Fallback if global function is missing
        const titleEl = document.getElementById('requestInformationProductName');
        if (titleEl) titleEl.textContent = `${type} - ${title}`;
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('overflow-hidden');
      }
    }

    const closeTrigger = e.target.closest('[data-close-modal]');
    if (closeTrigger) {
      e.preventDefault();
      if (typeof window.closeEnquiryModal === 'function') {
        window.closeEnquiryModal();
      } else {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('overflow-hidden');
      }
    }
  });

  // Close on ESC key
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      if (typeof window.closeEnquiryModal === 'function') {
        window.closeEnquiryModal();
      }
    }
  });
})();
